export default "__VITE_ASSET__CiElIIvp__"